import axiosInstance from './AxiosConfig';

export const fetchStadiumsByFederacion = async (idFederacion) => {
  try {
    const response = await axiosInstance.get(`/api/estadios?id_federacion=${idFederacion}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los estadios:', error);
    throw error;
  }
};

export const createStadium = async (newStadium) => {
  try {
    const response = await axiosInstance.post('/api/estadios', newStadium);
    return response.data;
  } catch (error) {
    console.error('Error al crear el estadio:', error);
    throw error;
  }
};

export const deleteStadium = async (idStadium) => {
  try {
    const response = await axiosInstance.delete(`/api/estadios/${idStadium}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar el estadio:', error);
    throw error;
  }
};

export const updateStadium = async (idStadium, data) => {
  try {
    const response = await axiosInstance.put(`/api/estadios/${idStadium}`, data);
    return response.data;
  } catch (error) {
    console.error('Error al modificar el estadio:', error);
    throw error;
  }
};